import pako from 'pako';
const validSupplantType = ['string', 'number', 'boolean'];
/**
 * string supplant.只接受string | number | boolean类型的替换。
 * @param targetStr 目标字符串
 * @param obj
 * @returns string
 * @example 
 * supplant('http://ptengine.com/{id}', { id: 'x' }) => "http://ptengine.com/x"
 * supplant('http://ptengine.com/{id}', { id: true }) => "http://ptengine.com/true"
 * supplant('http://ptengine.com/{id}', { id: { a: '123' } }) => "http://ptengine.com/"
 */
export function supplant(targetStr: string, obj: any): string {
    return targetStr.replace(/{([^{}]*)}/g, (_, b) => validSupplantType.includes(typeof obj?.[b]) ? obj?.[b] : '');
}

export function encodeUnicode(str: string) {
    var res = [];
    for (var i = 0; i < str.length; i++) {
        res[i] = ('00' + str.charCodeAt(i).toString(16)).slice(-4);
    }
    return '\\u' + res.join('\\u');
}

export function decodeUnicode(str: string): string {
    str = str.replace(/\\/g, '%');
    return unescape(str);
}

export function fistLetterUpper(str: string): string {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

// gzip
export function zip(str: string) {
    if (typeof str !== 'string') {
        str = JSON.stringify(str)
    }
    const binaryString = pako.gzip(str);
    return uint8arrayToBase64(binaryString)
}

// uint8arrayToBase64
function uint8arrayToBase64(u8Arr: any) {
    try {
        let CHUNK_SIZE = 0x8000; //arbitrary number
        let index = 0;
        let length = u8Arr.length;
        let result = '';
        let slice;
        while (index < length) {
            slice = u8Arr.subarray(index, Math.min(index + CHUNK_SIZE, length));
            result += String.fromCharCode.apply(null, slice);
            index += CHUNK_SIZE;
        }
        return btoa(result);
    }
    catch (e) {
        throw e;
    }
}
